const GLOBAL_CART_TTL = 10 * 60 * 1000; // 10 minutes
const EXPIRY_KEY = 'global_cart_expiry';


function setCartExpiry() {
    const expiry = Date.now() + GLOBAL_CART_TTL;
    localStorage.removeItem(EXPIRY_KEY);
    localStorage.setItem(EXPIRY_KEY, expiry.toString());
}

function getCartExpiry() {
    const val = localStorage.getItem(EXPIRY_KEY);
    return val ? parseInt(val, 10) : null;
}

function clearCart() {
    fetch('/cart/clear.js', {
        method: 'POST',
    }).then(() => {
        alert('Your cart expired and has been cleared.');
        localStorage.removeItem(EXPIRY_KEY);
        location.reload();
    });
}

function startGlobalCartTimer(isResetTimer = false) {
    const timerEl = document.getElementById('global-timer-text');

    if(isResetTimer){
        setCartExpiry();
    }
    const expiry = getCartExpiry();
    
    if (!expiry || isNaN(expiry)) {
        timerEl.textContent = '0:00';
        return;
    }

    const interval = setInterval(() => {
        const now = Date.now();
        const remaining = expiry - now;

        if (remaining <= 0) {
            clearInterval(interval);
            timerEl.textContent = '00:00';
            clearCart();
        } else {
            const minutes = Math.floor(remaining / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            timerEl.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        }
    }, 1000);
}

function isCartNotEmpty(callback) {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            return callback(cart.items.length > 0)
        });
}


document.addEventListener('DOMContentLoaded', () => {
    // Set expiry only if cart is not empty and expiry doesn't exist
    isCartNotEmpty((notEmpty) => {
        if (notEmpty && !getCartExpiry()) {
            setCartExpiry();
        }
        startGlobalCartTimer();
    });
});
